import React from "react";
import "../../Components/Menu/Menu.css";

export default function Complaint() {
  return (
    <div>
      <h4 className="sub-title">Klage til Datatilsynet</h4>
      <p className="content">
        <p>
          Hvis du mener at GMG behandler personopplysningene dine på en måte som
          er i strid med regelverket, kan du klage til Datatilsynet.
        </p>
        <p> Datatilsynet kontakter du på: </p>
        <p> Telefon: 22 39 69 00 </p>
        <p>
          E-post:
          <a className="mail-lab" href="mailto:postkasse@datatilsynet.no">
            postkasse@datatilsynet.no
          </a>
        </p>
        <p>Eller med vanlig post til: Postboks 8177 Dep., 0034 Oslo</p>
      </p>
    </div>
  );
}
